export default "__VITE_ASSET__D$TfYbQM__"